import { render, staticRenderFns } from "./furnishing_report.vue?vue&type=template&id=d6564542"
import script from "./furnishing_report.vue?vue&type=script&lang=js"
export * from "./furnishing_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports